if (!window.__averoakProductThumbnailsInitialized) {
  window.__averoakProductThumbnailsInitialized = true;

  function getThumbnailTrack(gallery) {
    if (!(gallery instanceof HTMLElement)) return null;
    return gallery.querySelector('.averoak-product-thumbnails__track');
  }

  function updateTrackAlignment(gallery) {
    const track = getThumbnailTrack(gallery);
    if (!(track instanceof HTMLElement)) return;

    track.classList.toggle('is-centered', track.scrollWidth <= track.clientWidth + 1);
  }

  function centerThumbnail(gallery, index) {
    const track = getThumbnailTrack(gallery);
    if (!(track instanceof HTMLElement)) return;

    const buttons = gallery.querySelectorAll('.averoak-product-thumbnails__button');
    const targetButton = buttons[index];
    if (!(targetButton instanceof HTMLElement)) return;

    updateTrackAlignment(gallery);

    const maxScrollLeft = Math.max(track.scrollWidth - track.clientWidth, 0);
    if (maxScrollLeft <= 1) {
      track.scrollLeft = 0;
      return;
    }

    const nextScrollLeft = Math.min(
      Math.max(targetButton.offsetLeft - (track.clientWidth - targetButton.clientWidth) / 2, 0),
      maxScrollLeft
    );

    track.scrollTo({ left: nextScrollLeft, behavior: 'instant' });
  }

  function observeTrack(gallery) {
    const track = getThumbnailTrack(gallery);
    if (!(track instanceof HTMLElement) || track.__averoakTrackObserved) return;

    track.__averoakTrackObserved = true;

    if (typeof ResizeObserver === 'function') {
      const resizeObserver = new ResizeObserver(() => {
        updateTrackAlignment(gallery);
      });

      resizeObserver.observe(track);
      track.__averoakResizeObserver = resizeObserver;
    }

    track.querySelectorAll('img').forEach((image) => {
      if (image.complete) return;
      image.addEventListener(
        'load',
        () => {
          updateTrackAlignment(gallery);
        },
        { once: true }
      );
    });
  }

  function syncGalleryThumbnails(gallery, index, options = {}) {
    if (!(gallery instanceof HTMLElement)) return;

    const { centerActive = true } = options;
    const buttons = gallery.querySelectorAll('.averoak-product-thumbnails__button');
    buttons.forEach((button, buttonIndex) => {
      button.setAttribute('aria-current', buttonIndex === index ? 'true' : 'false');
    });

    observeTrack(gallery);

    if (centerActive) {
      window.requestAnimationFrame(() => centerThumbnail(gallery, index));
    } else {
      updateTrackAlignment(gallery);
    }
  }

  function handleThumbnailClick(event) {
    const button = event.target instanceof Element ? event.target.closest('.averoak-product-thumbnails__button') : null;
    if (!(button instanceof HTMLButtonElement)) return;

    const gallery = button.closest('media-gallery');
    if (!(gallery instanceof HTMLElement)) return;

    const slideshow = gallery.querySelector('slideshow-component');
    const index = Number(button.dataset.thumbnailIndex || 0);

    event.preventDefault();

    if (slideshow && typeof slideshow.select === 'function') {
      slideshow.select(index, event, { animate: false });
    }

    syncGalleryThumbnails(gallery, index);
  }

  function handleSlideshowSelect(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const gallery = target.closest('media-gallery');
    if (!(gallery instanceof HTMLElement)) return;

    const index = Number(event.detail?.index || 0);
    syncGalleryThumbnails(gallery, index);
  }

  function initializeThumbnailState(root = document) {
    root.querySelectorAll('media-gallery').forEach((gallery) => {
      syncGalleryThumbnails(gallery, 0, { centerActive: false });
    });
  }

  document.addEventListener('click', handleThumbnailClick);
  document.addEventListener('slideshow:select', handleSlideshowSelect);
  document.addEventListener('variant:update', () => {
    window.requestAnimationFrame(() => initializeThumbnailState());
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeThumbnailState(), { once: true });
  } else {
    initializeThumbnailState();
  }
}
